import React, { useState } from 'react';

import { useTemplate } from '../../../../features/template/TemplateProvider';
import useApi from '../../../../hook/useApi';
import { ButtonCancel, ButtonPrimary } from '../../../../utils/Button';
import FocusControl from '../../../../utils/FocusControl';
import InputField, { SelectOption, addOption } from '../../../../utils/InputField';
import { useAgency } from '../../AgencyProvider';

function ModalCustomerMoveAgency() {
    const { setReloadKey, agencyInfo } = useAgency();
    const { setMessage } = useTemplate();
    const [isError, setIsError] = useState('');
    const [loading, setLoading] = useState(false);
    const { modalData, closeModal } = useTemplate();
    const { put } = useApi();
    const customerListData = agencyInfo?.list || [];

    const [formData, setFormData] = useState({
        AgencyId: 0,
        CustomerId: modalData?.id || 0,
        FullName: modalData?.fullName || '',
        Organization: modalData?.organization || '',
        ShortName: modalData?.shortName || '',
        ShortCode: modalData?.shortCode || '',
        Email: modalData?.primaryEmail || '',
        Phone: modalData?.primaryPhone || ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((d) => ({ ...d, [name]: value }));
    };
    const handleCreateCustomer = async (e) => {
        setLoading(true);
        e.preventDefault();
        try {
            const res = await put(`api/customers/${formData?.CustomerId}/move-to-under-agency`, {
                AgencyId: Number(formData?.AgencyId),
                CustomerId: formData?.CustomerId
            });
            if (res.error) {
                setIsError(res?.referenceName || '');
                throw new Error(res.message);
            } else {
                setMessage({ type: 'success', text: res.message });
                setReloadKey((k) => k + 1);
                closeModal();
            }
        } catch (err) {
            setMessage({ type: 'error', text: err?.message });
        } finally {
            setLoading(false);
        }
    };

    // Focus Control on Error
    FocusControl(isError, setIsError, formData);

    return (
        <form onSubmit={handleCreateCustomer} className="flex flex-col gap-4">
            <SelectOption
                label="Select Agency"
                placeholder="Agency"
                name="AgencyId"
                formData={formData}
                onChange={handleChange}
                options={customerListData
                    ?.filter((i) => i?.id !== 0)
                    .map((item) => addOption(item?.id, item?.organization, item?.id))}
                required
            />
            <InputField
                label="Full Name"
                name="FullName"
                placeholder='e.g. "Google"'
                formData={formData}
                onChange={handleChange}
                readOnly
            />
            <InputField
                label="Organization"
                name="Organization"
                placeholder='e.g. "Google"'
                formData={formData}
                onChange={handleChange}
                readOnly
            />
            <div className="flex flex-col sm:flex-row  justify-between items-center gap-4">
                <InputField
                    label="Email Address"
                    name="Email"
                    placeholder='e.g. mail@example.com"'
                    formData={formData}
                    onChange={handleChange}
                    readOnly
                />
                <InputField
                    label="Phone Number"
                    name="Phone"
                    placeholder='e.g. "+1 541 754 3010"'
                    formData={formData}
                    onChange={handleChange}
                    readOnly
                />
            </div>
            <div className="flex flex-col sm:flex-row  justify-between items-center gap-4">
                <InputField
                    label="Short Name"
                    name="ShortName"
                    placeholder='e.g. "John S."'
                    formData={formData}
                    onChange={handleChange}
                    readOnly
                />
                <InputField
                    label="Short Code"
                    name="ShortCode"
                    placeholder='e.g. "JS"'
                    formData={formData}
                    onChange={handleChange}
                    readOnly
                />
            </div>

            <div className="w-full flex justify-end items-center gap-2 mb-2">
                <ButtonCancel title="Cancel" onClick={() => closeModal()} />
                <ButtonPrimary title="Move Under Agency" btnType="submit" loading={loading} />
            </div>
        </form>
    );
}

export default ModalCustomerMoveAgency;
